import { Meteor } from 'meteor/meteor'
import useTracker from '../lib/useTracker'
import { useGlobalState } from '../store'
import type { GlobalState } from '../types/globalState'

const useActualOffer = () => {
  const [{ listOffers }]: GlobalState = useGlobalState('offers')

  const user = useTracker(() => Meteor.user(), [])

  return listOffers.find((o) => o._id === user?.profile.offerId)
}

export default useActualOffer
